import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import {
  Box,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import ErrorIcon from "@mui/icons-material/Error";

import { useFormContext } from "react-hook-form";
const Nav = (props: any) => {
  const [showContent, setShowContent] = useState(false);

  const {
    items,
    currentStep,
    setCurrentStep,
    PageContent,
    isMobileView,
    generalReducer,
    stepStatus,

    changeStepStatus,
  } = props;
  const {
    setValue,
    control,
    watch,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();
  const values = watch();
  const isStepLoading = (step: any) => stepStatus[step]?.loading;
  const isStepSubmitted = (step: any) => stepStatus[step]?.submitted;
  const isStepError = (step: any) => stepStatus[step]?.error;
  const SecondEl = ({ step }: any) => {
    if (stepStatus[step]?.error) {
      return <ErrorIcon sx={{ color: "red" }} />;
    }
    if (stepStatus[step]?.loading) {
      return <CircularProgress size={20} />;
    }
    if (stepStatus[step]?.submitted) {
      return <CheckCircleIcon sx={{ color: "#4EA643" }} />;
    } else {
      return <KeyboardArrowRightIcon sx={{ color: "#818181" }} />;
    }
  };
  const { manufacturer, attachments, models } = generalReducer;
  const BasicScreenLoading =
    manufacturer?.loading || attachments?.loading || models?.loading;
  const equipmentType = values?.equipmentType;

  const [navItems, setNavItems] = useState(items);

  useEffect(() => {
    setNavItems(
      equipmentType == 1
        ? items
        : items?.filter((el: any) => el != "Configurations")
    );
  }, [equipmentType]);

  useEffect(() => {
    changeStepStatus("Basic Details", "loading", BasicScreenLoading);
  }, [BasicScreenLoading]);

  return showContent && isMobileView ? (
    <Fragment>
      <ListItemButton sx={{ display: "flex", justifyContent: "flex-start" }}>
        <ListItemIcon onClick={() => setShowContent(false)}>
          <ArrowBackIcon />
        </ListItemIcon>
        <ListItemText
          sx={{ padding: "2px 0" }}
          primary={
            <Typography
              sx={{
                color: "#323232",
                fontSize: "13.5px",
                fontWeight: 600,
              }}
            >
              {currentStep}
            </Typography>
          }
        />
      </ListItemButton>
      <Divider variant="middle" />

      {PageContent}
    </Fragment>
  ) : (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        pt: "10px",
      }}
    >
      <Fragment>
        <Typography
          sx={{
            mb: 1,
            width: "100%",

            textAlign: "left",
            pl: "25px",
          }}
          fontWeight={500}
          fontSize={13.5}
          color="common.black"
        >
          List your equipment to follow these simple steps
        </Typography>

        <List
          sx={{
            width: "100%",
            // maxWidth: 360,
            bgcolor: "background.paper",
          }}
        >
          {navItems?.map((step: any, index: number) => {
            return (
              <Fragment key={step}>
                <ListItem
                  key={step}
                  secondaryAction={<SecondEl step={step} />}
                  disablePadding
                >
                  <ListItemButton
                    onClick={() => {
                      setCurrentStep(step);
                      isMobileView && setShowContent(true);
                    }}
                  >
                    <ListItemText
                      sx={{ padding: "2px 0" }}
                      id={step}
                      primary={
                        <Typography
                          sx={{
                            color: currentStep == step ? "#323232" : "#818181",
                            fontSize: "13.5px",
                            fontWeight: currentStep == step ? 600 : 400,
                          }}
                        >
                          {step}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
                {index != items?.length - 1 && (
                  <Divider variant="middle" component="li" />
                )}
              </Fragment>
            );
          })}
        </List>
      </Fragment>
    </Box>
  );
};

export default Nav;
